"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfServiceService = void 0;
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var backend_services_1 = require("@src/services/backend-services");
function getSelfServiceIndividual(ssid, config) {
    return __awaiter(this, void 0, void 0, function () {
        var fmsUrl, res, body, msg;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(fmsUrl + '/self-service/get-individual', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ ssid: ssid }),
                        })];
                case 1:
                    res = _b.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    body = _b.sent();
                    if (!res.ok) {
                        msg = (body === null || body === void 0 ? void 0 : body.displayMessage) || 'Failed getting customer';
                        return [2 /*return*/, { errorMessage: msg }];
                    }
                    return [2 /*return*/, (_a = body === null || body === void 0 ? void 0 : body.data) !== null && _a !== void 0 ? _a : { errorMessage: 'Empty response payload' }];
            }
        });
    });
}
function purchaseAdditionalModule(ssid, contractId, moduleId, paymentFrequencyId, moduleName, aovGain, config) {
    return __awaiter(this, void 0, void 0, function () {
        var fmsUrl, res, body, msg;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(fmsUrl + '/self-service/purchase-module', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                ssid: ssid,
                                contractId: contractId,
                                moduleId: moduleId,
                                moduleName: moduleName,
                                paymentFrequencyId: paymentFrequencyId,
                                aovGain: aovGain,
                                sendEmailTo: (_a = config.get.selfService) === null || _a === void 0 ? void 0 : _a.sendModuleUpgradeEmailTo,
                            }),
                        })];
                case 1:
                    res = _b.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    body = _b.sent();
                    if (!res.ok) {
                        msg = (body === null || body === void 0 ? void 0 : body.displayMessage) || 'Failed purchasing module';
                        return [2 /*return*/, { errorMessage: msg }];
                    }
                    return [2 /*return*/, { success: true }];
            }
        });
    });
}
function switchMembership(ssid, switchData, config) {
    return __awaiter(this, void 0, void 0, function () {
        var fmsUrl, switchDataEnriched, res, body, msg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment);
                    switchDataEnriched = __assign(__assign({}, switchData), { source: 'self-service-membership-upgrade', ssid: ssid });
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(fmsUrl + '/self-service/switch-membership', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(switchDataEnriched),
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    body = _a.sent();
                    if (!res.ok) {
                        msg = (body === null || body === void 0 ? void 0 : body.displayMessage) || 'Failed switching membership';
                        return [2 /*return*/, { errorMessage: msg }];
                    }
                    return [2 /*return*/, { success: true }];
            }
        });
    });
}
function updateCustomerData(payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var fmsUrl, response, data, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fmsUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("".concat(fmsUrl, "/self-service/update-customer-data"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(payload),
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _b.sent();
                    if (!response.ok) {
                        return [2 /*return*/, {
                                errorMessage: (_a = data === null || data === void 0 ? void 0 : data.errorMessage) !== null && _a !== void 0 ? _a : 'Failed to update customer data.',
                            }];
                    }
                    return [2 /*return*/, data];
                case 4:
                    error_1 = _b.sent();
                    console.error('Failed updating customer data', error_1);
                    return [2 /*return*/, {
                            errorMessage: 'Failed to update customer data.',
                        }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getUpcomingAppointments(ssid, config) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, body, appointments;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    url = new URL((0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment) + '/self-service/appointments/upcoming');
                    url.searchParams.set('ssid', ssid);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(url.toString(), { method: 'GET' })];
                case 1:
                    response = _d.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    body = _d.sent();
                    if (!response.ok) {
                        return [2 /*return*/, { errorMessage: (_a = body === null || body === void 0 ? void 0 : body.displayMessage) !== null && _a !== void 0 ? _a : 'Failed getting upcoming appointments.' }];
                    }
                    appointments = (_c = (_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.appointments) !== null && _c !== void 0 ? _c : body === null || body === void 0 ? void 0 : body.appointments;
                    return [2 /*return*/, Array.isArray(appointments) ? appointments : []];
            }
        });
    });
}
function setAppointmentAttendance(ssid, appointmentDocId, attendanceStatus, config) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, body;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat((0, infrastructure_const_1._GetCloudFunctionUrl)('fms', config.get.environment), "/self-service/appointments/").concat(encodeURIComponent(appointmentDocId), "/set-attendance");
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(url, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ ssid: ssid, attendanceStatus: attendanceStatus }),
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    body = _b.sent();
                    if (!response.ok) {
                        return [2 /*return*/, { errorMessage: (_a = body === null || body === void 0 ? void 0 : body.displayMessage) !== null && _a !== void 0 ? _a : 'Failed updating appointment attendance.' }];
                    }
                    return [2 /*return*/, { success: true }];
            }
        });
    });
}
exports.SelfServiceService = {
    getSelfServiceIndividual: getSelfServiceIndividual,
    purchaseAdditionalModule: purchaseAdditionalModule,
    switchMembership: switchMembership,
    updateCustomerData: updateCustomerData,
    getUpcomingAppointments: getUpcomingAppointments,
    setAppointmentAttendance: setAppointmentAttendance,
};
